import { Chip, Stack } from '@mui/material';
import { Time } from '../../common/MomentTime';
import { DownloadFile } from './DownloadFile';

export const getColumns = (rows) => {
  const latestCreatedAt = rows?.length
    ? Math.max(...rows.map((row) => new Date(row.CREATED_AT).getTime()))
    : null;

  return [
    {
      field: 'CREATED_AT',
      headerName: 'Date/Time',
      valueGetter: (params, row) => Time.University(row.CREATED_AT).format('MM/DD/YYYY h:mm A'),
      flex: 1,
    },
    {
      field: 'MIDAS',
      headerName: 'MIDAS',
      flex: 1,
    },
    {
      field: 'FILE_PATH',
      headerName: 'File Uploaded',
      renderCell: (params) => {
        const {
          DATE: date,
          CREATED_AT: createdAt,
          FILE_NAME: fileName,
          FILE_PATH: filePath,
        } = params.row;

        const isCurrent = new Date(createdAt).getTime() === latestCreatedAt;

        return (
          <Stack direction="row" gap={1} alignItems="center">
            <DownloadFile
              date={date}
              createdAt={createdAt}
              fileName={fileName}
              filePath={filePath}
            />
            {isCurrent && <Chip size="small" label="Current" color="success" variant="outlined" />}
          </Stack>
        );
      },

      flex: 3,
    },
  ];
};
